export default "assets/images/icons/brown-circle-acb76d5a.svg";